import { axios } from '@/utils/request'

const api = {
  queryPageTypeList: '/sso/pageTypeInfo/queryPageTypeList', // 获取页面类型
  selectPageType: '/sso/pageTypeInfo/selectPageType' // 选中页面类型
}

export default api
export const queryPageTypeList = params => axios.post(api.queryPageTypeList, params)
export const selectPageType = params => axios.post(api.selectPageType, params)
